import { createDecorator } from '../../instantiation/common/instantiation.js';
const IClipboardService = ( createDecorator('clipboardService'));
export { IClipboardService };
